import React, { useEffect, useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon';
import HttpClient from '../../utils/HttpClient';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import toast from 'react-hot-toast';
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal';
import { Link, useNavigate } from 'react-router-dom';
import DetailsModal from '../../Component/Modal/DetailsModal';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import checktick from "../../Images/check-mark.png"
import user from "../../Images/user.png"
import userhistory from "../../Images/bills.png"
import cards from "../../Images/hand-gesture.png"
import partner from "../../Images/partnership-icon-10404.jpg"
import crossIcon from "../../Images/remove-icon-png-7115.png"
import './ViewTable.css'
import BusinessLIstingModal from '../../Component/Modal/BusinessLIstingModal';
import BusinessLikesModal from '../../Component/Modal/BusinessLikesModal';
import { formatLikeCounter } from '../../utils/helper';
import BusinessFollowModal from '../../Component/Modal/BusinessFollowModal';
import BlmEnquiryList from './BlmEnquiryList';



const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const format1 = "DD-MM-YYYY, h:mm a"


const MemberBusinessListPending = () => {
    const [AllData, setAllData] = useState([]);
    const [ExcelSheetData, setExcelSheetData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);
    const [isBusinessFollowModalOpen, setIsBusinessFollowModalOpen] = useState(false);
    const [isBusinessLikeModalOpen, setIsBusinessLikeModalOpen] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState("");
    const [selectedBusinessLikeDetails, setSelectedBusinessLikeDetails] = useState();
    const [selectedBusinessFollowDetails, setSelectedBusinessFollowDetails] = useState();
    const [searchInput, setSearchInput] = useState('');
    const [filterCountryState, setfilterCountryState] = useState(false);
    const navigate = useNavigate()

    // column
    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "5%",
            wrap: true
        },
        {
            name: 'View',

            cell: (row) => (
                <>
                    {
                        row.businessStatus && (
                            <>
                                <i className="fa-solid fa-eye " onClick={() => handleBusinessView(row.id)}
                                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i>
                            </>
                        )
                    }
                </>
            ),

            width: "10%",
            wrap: true,
        },
        {
            name: 'Like(s)',
            cell: (row) => (
                <>
                    {
                        row.businessStatus && (
                            <>
                                {row?.businessLikeCount ? (<>{formatLikeCounter(row.businessLikeCount)}&nbsp;<i className="fa-solid fa-eye " onClick={() => handleBusinessLikesView(row)}
                                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i></>) : formatLikeCounter(0)}
                            </>
                        )
                    }
                </>
            ),

            width: "10%",
            wrap: true,
            align: "center",
        },
        {
            name: 'Follower(s)',

            cell: (row) => (
                <>
                    {
                        row.businessStatus && (
                            <>
                                {row?.businessFollowCount ? (<>{formatLikeCounter(row.businessFollowCount)}&nbsp;<i className="fa-solid fa-eye " onClick={() => handleBusinessFollowersView(row)}
                                    style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i></>) : formatLikeCounter(0)}
                            </>
                        )
                    }
                </>
            ),

            width: "10%",
            wrap: true,
            align: "center",
        },
        {
            name: 'Enquiry',

            cell: (row) => (
                <>
                    {row?.referenQuiries.length > 0 ? (<>{formatLikeCounter(row?.referenQuiries.length)}&nbsp;<i className="fa-solid fa-eye " onClick={() => handleEnquiryDisplay(row?.referenQuiries)}
                        style={{ cursor: "pointer", color: 'darkBlue', fontSize: '12px' }}></i></>) : formatLikeCounter(0)}
                </>
            ),
            width: "5%",
        },

        {
            name: 'Company Name',
            selector: row => row.companyName,
            width: "10%",
            wrap: true
        },
        {
            name: 'Company Type',
            selector: row => row.TypeOfCompany,
            width: "15%"
        },
        // {
        //     name: 'Services',
        //     selector: row => {
        //         return (
        //             <>
        //                 <ul>
        //                     {
        //                         row?.services?.map((item) => { return <><li>{item}</li></> })
        //                     }
        //                 </ul>
        //             </>
        //         )
        //     },
        //     width: "13%",
        //     wrap: true,
        // },
        // {
        //     name: 'Keywords',
        //     selector: row => {
        //         return (
        //             <>
        //                 {
        //                     row?.keywords?.map((item, key) => { return <>{item}{row?.keywords?.length > key + 1 && ", "}</> })
        //                 }
        //             </>
        //         )
        //     },
        //     width: "13%",
        //     wrap: true,
        // },
        {
            name: 'Person Name',
            selector: row => row.personName,
            width: "10%",
            wrap: true
        },
        {
            name: 'Upgrade',
            selector: row => row.upgrade,
            width: "10%"
        },
        // {
        //     name: 'Status',
        //     selector: row => row.status,
        //     width: "10%"
        // },
        {
            name: 'Business Page',
            selector: row => row.businessStatus,
            width: "10%"
        },
        {
            name: 'Action',
            selector: row => row.action,
            width: "5%"
        },
    ];

    const [displayEnquiry, setDisplayEnquiry] = useState(false)
    const [postEnquiry, setPostEnquiry] = useState([])
    //Enquiry VIEW
    const handleEnquiryDisplay = async (data) => {
        setDisplayEnquiry(true)
        setPostEnquiry(data)
    }

    const getAllData = async () => {
        setIsLoading(true);
        const res = await HttpClient.requestData("user", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setIsLoading(false);
            apiData = res?.data
            // .filter((item) => item.businessStatus && item.status==="Pending")
            .filter((item) => item.status==="Pending")
            .map((item, i) => ({
                id: item?._id,
                sl: i + 1,
                TypeOfCompany: item?.TypeOfCompany,
                companyName: item?.companyName,
                personName: item?.gender + ". " + item?.personName,
                services: item?.businessProductCat,
                keywords: item?.businessProductkeywords,
                designation: item?.designation,
                emailId: item?.emailId,
                telephoneNo: item?.telephoneNo,
                mobileNo: item?.mobileNo,
                whatsappNo: item?.whatsappNo,
                rewardPoints: item?.rewardPoints,
                directoryCount: item?.directoryCount,
                upgradeStatus: item?.upgradeStatus ?
                    <img src={checktick} className='w-25 mx-4' /> :
                    <img src={user} className='w-25 mx-4' />,
                partnerStatus: !item?.partnerStatus ?
                    <img src={crossIcon} className='w-25 mx-4' /> :
                    <img src={partner} className='mx-3' style={{ width: "50px" }} />,
                upgradeDate: item?.upgradeDate ? moment(item?.upgradeDate).format(format1) : "N/A",
                websiteLink: item?.websiteLink,
                address: item?.address,
                location: item?.location,
                userName: item?.userName,
                activationCode: item?.activationCode,
                createdOn: moment(item?.createdOn).format(format1),
                referenQuiries: item?.referenQuiries,
                loginStatus: item?.loginStatus ? <button

                    type="button" className="btn btn-success floating-message px-3"
                    data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                    style={{ fontSize: "16px" }}>Active</button> : <button

                        type="button" className="btn btn-danger floating-message px-3"
                        data-toggle="tooltip" data-placement="top" title="Click to Activate">
                    Inactive
                </button>,
                dribbbleLink: item?.dribbbleLink,
                facebookLink: item?.facebookLink,
                instaLink: item?.instaLink,
                linkedInLink: item?.linkedInLink,
                youtubeLink: item?.youtubeLink,
                country: item?.country,
                emirate: item?.emirate,
                designation: item?.designation,
                businessStatus: item?.businessStatus,

                businessWebsiteLink: item?.businessWebsiteLink,
                businessFacebookLink: item?.businessFacebookLink,
                businessInstaLink: item?.businessInstaLink,
                businessLinkedInLink: item?.businessLinkedInLink,
                businessLocationLink: item?.businessLocationLink,

                businessLikeCount: item?.businessLikeCount,
                businessLikes: item?.businessLikes.sort(
                    (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                ),
                businessFollowCount: item?.businessFollowCount,
                businessFollow: item?.businessFollow.sort(
                    (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                ),

                status: <div>
                    {
                        item?.status === "Pending" ? <button
                            onClick={() => handleActive(item?._id)}
                            type="button" className="btn btn-danger floating-message px-3"
                            data-toggle="tooltip" data-placement="top" title="Click to Activate">
                            Pending
                        </button> : <button
                            onClick={() => handlePending(item?._id)}
                            type="button" className="btn btn-success floating-message px-3"
                            data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                            style={{ fontSize: "16px" }}>{item?.status}</button>
                    }
                </div>,
                businessStatus: <div>
                {
                    item?.businessStatus === false ? <button
                        onClick={() => handleActive(item?._id)}
                        type="button" className="btn btn-danger btn-sm _floating-message _px-3"
                    // data-toggle="tooltip" data-placement="top" title="Click to Activate"
                    >
                        Inactive<span style={{ fontSize: "80%", display: "block" }}>Click to Activate</span>
                    </button> : <button
                        onClick={() => handlePending(item?._id)}
                        type="button" className="btn btn-success btn-sm _floating-message _px-3"
                    // data-toggle="tooltip" data-placement="top" title="Click to Deactivate"
                    >
                        Active<span style={{ fontSize: "80%", display: "block" }}>Click to Deativate</span>
                    </button>
                }
            </div>,
                upgrade: <div>
                    {
                        item?.planUpgradeRequested ?
                            <button
                                // onClick={(e) => handleUpgrade(e, item?._id, item?.upgradedSubscriptionId, item?.passwordView)}
                                onClick={(e) => handlePlanUpgrade(e, item?._id)}
                                type="button" className="btn btn-sm btn-success my-2"
                            // data-toggle="tooltip" data-placement="top" title={`Upgrade to ${item.subscriptionId} plan`}
                            >
                                Upgrade<br />{item?.upgradedSubscriptionData?.plan} Plan
                            </button>
                            :
                            <button
                                type="button" className="btn btn-sm my-2" disabled>
                                NOT<br />REQUESTED
                            </button>
                    }
                </div>,

                action: <EditDeleteIcon
                    onClickEdit={(e) => handleEdit(item)}
                />,
                // History: <div><Link to={`/purchase-history/${item?._id}`}><img src={userhistory} style={{ width: "35px", height: "35px", cursor: "pointer" }} title="Purchase History" /></Link>
                //     <Link to={`/reward-history/${item?._id}`}><img src={cards} style={{ width: "35px", height: "35px", cursor: "pointer", marginLeft: "10px" }} title='Reward History' /></Link></div>,


            }));
            // _setExcelSheetData(res?.data?.map((item, i) =>
            // ({
            //     CompanyName: item?.companyName,
            //     TypeOfCompany: item?.TypeOfCompany,
            //     Service: item?.businessProductCat?.join(', '),
            //     Keywords: item?.businessProductkeywords?.join(', '),
            //     personName: item?.gender + ". " + item?.personName,
            //     Website: item?.businessWebsiteLink,
            //     Facebook: item?.businessFacebookLink,
            //     Instagram: item?.businessInstaLink,
            //     LinkedIn: item?.businessLinkedInLink,
            //     Location: item?.businessLocationLink
            // })

            // setExcelSheetData(apiData?.map((item, i) =>
            //     ({
            //         CompanyName: item?.companyName,
            //         TypeOfCompany: item?.TypeOfCompany,
            //         Service: item?.businessProductCat?.join(', '),
            //         Keywords: item?.businessProductkeywords?.join(', '),
            //         personName: item?.gender + ". " + item?.personName,
            //         Website: item?.businessWebsiteLink,
            //         Facebook: item?.businessFacebookLink,
            //         Instagram: item?.businessInstaLink,
            //         LinkedIn: item?.businessLinkedInLink,
            //         Location: item?.businessLocationLink
            //     })
            // ))
        } else {
            setIsLoading(false);
        }

        // Filter data based on search input
        const filteredData = apiData?.filter(item =>
            item?.personName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.companyName?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.country?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emirate?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.designation?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.emailId?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.mobileNo?.toString()?.includes(searchInput)
        );

        setAllData(filteredData);

        setExcelSheetData(filteredData?.map((item, i) =>
        ({
            CompanyName: item?.companyName,
            TypeOfCompany: item?.TypeOfCompany,
            Services: item?.services?.join(', '),
            Keywords: item?.keywords?.join(', '),
            personName: item?.personName,
            Website: item?.businessWebsiteLink,
            Facebook: item?.businessFacebookLink,
            Instagram: item?.businessInstaLink,
            LinkedIn: item?.businessLinkedInLink,
            Location: item?.businessLocationLink
        })
        ))
        // setExcelSheetData(filteredData)
    }

    //MODAL VIEW
    const handleView = async (id) => {

        setSelectedDetails(id);
        setIsModalOpen(true);
    }
    //BUSINESSMODAL VIEW
    const handleBusinessView = async (id) => {

        setSelectedDetails(id);
        setIsBusinessModalOpen(true);
    }
    //BUSINESS LIKES MODAL VIEW
    const handleBusinessLikesView = async (data) => {

        setSelectedBusinessLikeDetails(data?.businessLikes);
        setIsBusinessLikeModalOpen(true);
    }
    //BUSINESS FOLLOW MODAL VIEW
    const handleBusinessFollowersView = async (data) => {

        setSelectedBusinessFollowDetails(data?.businessFollow);
        setIsBusinessFollowModalOpen(true);
    }
    //Activate
    const handlePending = async (id) => {
        setIsLoading(true);
        const data = {
            status: "Pending",
            businessStatus: false,
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Deactivated Successfully");
            getAllData();
        } else {
            setIsLoading(false);
        }
    }
    //Pending
    const handleActive = async (id) => {
        setIsLoading(true);
        const data = {
            status: "Active",
            businessStatus: true,
        }

        const res = await HttpClient.requestData(`activateUser/${id}`, "PUT", data);
        if (res && res?.status) {
            setIsLoading(false);
            toast.success("Status Activated Successfully");
            getAllData();
        }
    }
    //Delete
    const handleDelete = (id) => {
        const del = async () => {
            setIsLoading(true);
            const res = await HttpClient.requestData("user/" + id, "DELETE")
            if (res && res?.status) {
                setIsLoading(false);
                getAllData();

                toast.success("id Deleted Successfully");
            } else {
                setIsLoading(false);
                toast.error(res?.message || "Something Wrong");
            }
        }

        DeleteConfirmModal(del);
    }

    //edit
    const handleEdit = (item) => {
        navigate("/member-business-list-edit", { state: item })
    }

    //Downloload EXCEL DATA
    // Function to export data to Excel
    const exportToExcel = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const fileName = 'member_business_list';

        const ws = XLSX.utils.json_to_sheet(ExcelSheetData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
    };

    useEffect(() => {
        getAllData();
    }, [searchInput])

    const toggleEnquiryView = () => {
        setDisplayEnquiry(!displayEnquiry)
    }

    const handleUpgrade = async (e, id, plan, code) => {
        e.preventDefault()
        const data = {
            subscriptionId: plan,
            planUpgradeRequested: false,
            password: code,
        }
        const res = await HttpClient.requestData("user/" + id, "PUT", data)
        if (res && res?.status) {
            toast.success("Upgraded Succesfully")
            // navigate("/member-business-list")
            getAllData();
        }
        else {
            toast.error(res?.msg)
        }
    }

    const handlePlanUpgrade = async (e, id) => {
        e.preventDefault()
        const res = await HttpClient.requestData("upgrade-plan-approve/" + id, "PUT")
        if (res && res?.status) {
            toast.success("Upgraded Succesfully")
            // navigate("/non-member-business-list")
            getAllData();
        }
        else {
            toast.error(res?.msg)
        }
    }

    return (
        <>
            {
                displayEnquiry ? (<BlmEnquiryList data={postEnquiry} backToPosts={toggleEnquiryView} />) :
                    (
                        <>
                            <div className="d-flex justify-content-end">
                                <div className="form-header">

                                    <CustomLoader loading={isLoading} />
                                    <section className="piechartsBox_area">
                                        <div
                                            style={headLineStyle}
                                            className="page-headline"
                                        >
                                            Pending Member User
                                        </div>
                                        <div className=" d-flex justify-content-between  mb-2" >
                                            {/* filter by country and state */}
                                            {!filterCountryState &&
                                                <div className="d-flex flex-column  justify-content-between  mt-3" >
                                                    {/* <div className='mb-2'>
                                    <label htmlFor="formGroupExampleInput">Country<span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="formGroupExampleInput">Emirate <span className="text-danger">&nbsp;</span></label>
                                    <select class="hello">
                                        <option selected value="0">Pure CSS Select</option>
                                        <option value="1">No Wrapper</option>
                                        <option value="2">No JS</option>
                                        <option value="3">Nice!</option>
                                    </select>
                                </div> */}
                                                </div>}
                                            <div className="Search_box">
                                                <form className="form-inline">
                                                    <input
                                                        className="form-control h-75"
                                                        type="search"
                                                        placeholder="Search"
                                                        aria-label="Search"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                    />
                                                    <div className="Search_icon">
                                                        <i className="fa-solid fa-magnifying-glass"></i>
                                                    </div>
                                                </form>
                                                <div className="d-flex justify-content-end">
                                                    {/* Your existing JSX code */}
                                                    <button className="btn btn-primary" onClick={exportToExcel}>Export to Excel</button>
                                                    {/* Your existing JSX code */}
                                                </div>
                                            </div>
                                        </div>


                                        <form>

                                            <div>

                                                <DataTable
                                                    columns={columns}
                                                    data={AllData}
                                                    pagination
                                                    striped
                                                    className=" rounded "
                                                    customStyles={customStyles}
                                                />
                                            </div>
                                        </form>
                                    </section>
                                </div>
                                <DetailsModal
                                    isOpen={isModalOpen}
                                    closeModal={() => setIsModalOpen(false)}
                                    details={selectedDetails}
                                />
                                <BusinessLIstingModal
                                    isOpen={isBusinessModalOpen}
                                    closeModal={() => setIsBusinessModalOpen(false)}
                                    details={selectedDetails}
                                />
                                <BusinessLikesModal
                                    isOpen={isBusinessLikeModalOpen}
                                    closeModal={() => setIsBusinessLikeModalOpen(false)}
                                    details={selectedBusinessLikeDetails}
                                />
                                <BusinessFollowModal
                                    isOpen={isBusinessFollowModalOpen}
                                    closeModal={() => setIsBusinessFollowModalOpen(false)}
                                    details={selectedBusinessFollowDetails}
                                />
                            </div>
                        </>
                    )
            }
        </>

    )
}

export default MemberBusinessListPending; 